<template>
  <div class="mb-2">
    <div class="row">
      <div class="col">
        <div class="passoRegistro_header mb-3">
          <h3 class="passoRegistro_header_title">
            Registrador
          </h3>
        </div>
        <div class="row px-2">
          <div class="col-5">
            <div class="form-group">
              <label class="label">
                Nome do digitador
              </label>
              <select ref="nome_digitador"
                      v-model="form.digitador"
                      v-validate="'required'"
                      class="form-control form-control-sm"
                      :class="{'is-invalid' : errors.has('digitador')}"
                      required
                      name="digitador"
                      @change="changed">
                <option :value="null">
                  Selecione o digitador:
                </option>
                <option v-for="(digitador, index) of digitadores"
                        :key="index"
                        :value="digitador.nome">
                  {{ digitador.nome }}
                </option>
              </select>
              <small v-if="errors.has('digitador')"
                     class="invalid-feedback">
                {{ errors.first('digitador') }}
              </small>
            </div>
          </div>

          <div class="col-4">
            <div class="form-group">
              <label class="label">
                Escrevente
              </label>
              <select id="selectEscrevente"
                      v-model="form.escrevente"
                      v-validate="'required'"
                      class="form-control form-control-sm"
                      :class="{'is-invalid' : errors.has('escrevente')}"
                      required
                      name="escrevente"
                      @change="changeEscrevente()">
                <option :value="null">
                  Selecione o escrevente:
                </option>
                <option v-for="(escrevente, index) of escreventes"
                        :key="index"
                        :value="escrevente.nome">
                  {{ escrevente.nome }}
                </option>
              </select>
              <small v-if="errors.has('escrevente')"
                     class="invalid-feedback">
                {{ errors.first('escrevente') }}
              </small>
            </div>
          </div>

          <div class="col-3">
            <div class="form-group">
              <label
                class="label"
                :class="{'label_error': error_data}"
                for="data_registro">Data do Registro
                <IconSvg v-if="error_data"
                         class="icon-error-campo"
                         icon="alert" />
              </label>
              <input
                id="data_registro"
                v-model="form.data_registro"
                v-validate="`date_format:yyyy-MM-dd|date_between:${ '1500-01-01' },${ '2500-01-01' }, (include)`"
                required
                class="form-control form-control-sm"
                name="data_registro"
                :class="{ 'is-invalid': errors.has('data_registro') || error_data}"
                placeholder="23/11/2020"
                type="date"
                @change="validateInputs('data_registro')">
              <small v-if="errors.has('data_registro')"
                     class="invalid-feedback">{{ errors.first('data_registro') }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div>
      <div class="row">
        <div class="col">
          <div class="passoRegistro_header mt-2 mb-3">
            <h3 class="passoRegistro_header_title">
              Registro
            </h3>
          </div>
        </div>
      </div>
      <div v-if="!form.registro_id && !propLegado"
           class="col-12 d-inline-flex m-0 p-0">
        <div class="col-sm-12 px-2">
          <div class="form-group">
            <label for=""
                   class="label d-block">1ª via ou Legado</label>
            <span class="custom-control custom-radio custom-control-inline">
              <input
                id="primeiraViaRegistro"
                v-model="form.origem"
                class="custom-control-input"
                checked
                name="primeiraViaRegistro"
                type="radio"
                value="novo"
                @change="changeOrigin('novo')"
                @keyup.enter="form.origem = 'novo'">
              <label
                class="custom-control-label"
                for="primeiraViaRegistro">1ª via</label>
            </span>

            <span class="custom-control custom-radio custom-control-inline">
              <input
                id="legadoRegistro"
                v-model="form.origem"
                class="custom-control-input"
                name="legadoRegistro"
                value="legado"
                type="radio"
                @change="changeOrigin('legado')"
                @keyup.enter="form.origem = 'legado'">
              <label
                class="custom-control-label"
                for="legadoRegistro">Legado</label>
            </span>
          </div>
        </div>
      </div>
      <div v-if="form.origem === 'legado' || form.registro_id"
           class="row px-2 mb-4">
        <div class="col-2">
          <label class="label"
                 for="AcervoRegistro">Acervo</label>
          <select id="AcervoRegistro"
                  v-model="form.acervo"
                  v-validate="'required'"
                  :class="{'is-invalid' : errors.has('registro_acervo')}"
                  class="form-control form-control-sm"
                  name="registro_acervo"
                  placeholder="00"
                  @change="changed()">
            <option :value="1">
              01
            </option>
            <option :value="2">
              02
            </option>
          </select>
        </div>

        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Livro</label>
          <input v-model="form.livro.num_livro"
                 v-validate="'required'"
                 type="number"
                 name="registro_livro"
                 :class="{'is-invalid' : errors.has('registro_livro')}"
                 class="form-control form-control-sm"
                 @change="changed()">
        </div>

        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Folha</label>
          <input v-model="form.folha"
                 v-validate="'required'"
                 type="number"
                 name="registro_folha"
                 :class="{'is-invalid' : errors.has('registro_folha')}"
                 class="form-control form-control-sm"
                 @change="changed()">
        </div>

        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Termo</label>
          <input v-model="form.termo"
                 v-validate="'required'"
                 type="number"
                 name="registro_termo"
                 :class="{'is-invalid' : errors.has('registro_termo')}"
                 class="form-control form-control-sm"
                 @change="changed()">
        </div>

        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Lado</label>
          <select v-model="form.lado"
                  v-validate="'required'"
                  name="registro_lado"
                  :class="{'is-invalid' : errors.has('registro_lado')}"
                  class="form-control form-control-sm"
                  @change="changed()">
            <option>FRENTE</option>
            <option>VERSO</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  /* services */
  import UsuarioService from "@/services/Auth/UsuarioService"

  /* libraries */
  import { mapGetters } from "vuex"

  export default {
    name: 'Registro',
    props: {
      propRegistro: {type: Object, default: () => ({})},
      propCorrecoes: {type: Object, default: () => ({})},
      propTab: {type: Number, default: () => 0},
      propLegado: {type: Boolean, default: false}
    },
    inject: ['$validator'],
    data () {
      return {
        digitadores: [],
        escreventes: [],
        form: {
          data_registro: null,
          digitador: null,
          escrevente: null,
          termo: null,
          livro: {
            num_livro: null
          },
          folha: null,
          lado: null,
          oficial: null,
          cargo_escrevente: null,
          acervo: null
        },
        sequenciaRegistro: null,
        error_data: false,
        data_registro_origin: null
      }
    },
    computed: {
      ...mapGetters({
        cartorioObj: 'auth/getCartorioObj'
      }),
    },
    watch: {
      propRegistro ()  {
        this.form = this.propRegistro
        this.getSequenciaRegistro()
      },
      propCorrecoes () {
        this.verifyErrorsCarga()
      },
      propTab () {
        if (this.propTab == 3) {
          this.$refs.nome_digitador.focus()
        }
      }
    },
    mounted () {
      this.getSequenciaRegistro()
      this.loadUsers()
      if (Object.values(this.propRegistro).length) this.form = this.propRegistro
      this.verifyErrorsCarga()
      this.$refs["nome_digitador"].focus()

      if (this.propRegistro && !!this.propRegistro.registro_id) {
        this.form.acervo = this.propRegistro.livro.acervo
      }

      if (this.propLegado) this.form.origem = 'legado'
    },
    methods: {
      getSequenciaRegistro () {
        if (!this.sequenciaRegistro  && this.propRegistro.registro_id ) {
          // pegando sequencia de dado do registro para identificar mudanca
          let { livro: { num_livro, acervo }, folha, termo } = this.propRegistro
          this.sequenciaRegistro = [num_livro, acervo, folha, termo].join('')
        }
        this.data_registro_origin = !!this.propRegistro ? this.propRegistro.data_registro : null
      },
      async loadUsers () {
        const response = await UsuarioService.getUsuarios()
        if (!response || !response.data) return

        this.escreventes = []
        this.digitadores = []

        let usuarios = response.data || []

        this.digitadores = usuarios
        this.escreventes = usuarios.filter(usuario => usuario.escrevente === 1 )

        const user = this.$store.state.auth.usuario

        if (!this.form.escrevente && !!user.escrevente) {
          this.form.escrevente = user.nome
          this.form.cargo_escrevente = user.cargo
        }
        if (!this.form.digitador) this.form.digitador = user.nome

        // nome oficial
        if (!this.form.oficial) {
          this.form.oficial = this.cartorioObj.nome_oficial
        }
      },
      validateInputs (input) {
        const res = this.$validator.validate(input)

        if (res) this.changed()
      },
      changed () {
        if (this.propRegistro.registro_id) {
          let { livro: { num_livro }, acervo, folha, termo } = this.form
          const sequenciaLocal = [num_livro, acervo, folha, termo].join('')

          if ((this.sequenciaRegistro != sequenciaLocal) || (this.form.data_registro != this.data_registro_origin)) {
            this.form.origem = 'legado'
          } else {
            this.form.origem = 'novo'
          }
        }

        this.$emit('change', this.form)
      },
      verifyErrorsCarga () {
        this.error_data = false

        Object.keys(this.propCorrecoes).forEach(key => {
          if ([`DATA DO REGISTRO`].indexOf(key) != -1) this.error_data = true
        })
      },
      deleteError (errors) {
        this.$emit('deleteError', errors)
      },
      changeOrigin (origem) {
        if (origem === 'novo') {
          this.form = {
            ...this.form,
            termo: null,
            livro: {
              num_livro: null
            },
            folha: null,
            lado: null,
            acervo: null
          }
        }
        else {
          this.form.acervo = 1 // trazemos como recomendação o acervo = 1
        }

        this.changed()
      },
      changeEscrevente () {
        if (this.form.escrevente) {
          const selectEscreventes = document.getElementById('selectEscrevente')
          this.form.cargo_escrevente  = this.escreventes[selectEscreventes.selectedIndex - 1].cargo
        }
        this.changed()
      }
    }
  }
</script>
<style lang="scss">
  @import '../../../scss/_utilities/exports';

  .passoRegistro {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_title {
        @extend %titleBox_title;
      }
    }
  }
</style>
